var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"mb-4 shadow-sm",attrs:{"header":"Account-based Access"}})}
var staticRenderFns = []

export { render, staticRenderFns }